import { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import ConfirmDialog from "../../../../components/dialog/ConfirmDialog";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { OrderDetails } from "./order-details";
import { OrderEdit } from "./order-edit";
import { PlaceholderPicker } from "src/components/placeholder/PlaceholderPicker";
import { getPlaylistsById, syncPlaylistSettings } from "src/redux/actions/Playlist";
import { useDispatch } from "react-redux";
import { Backdrop, CircularProgress, Dialog } from "@mui/material";

export const OrderDrawer = (props) => {
  const {
    container,
    onClose,
    open,
    order,
    orders,
    onEdit,
    onSelectFiles,
    deletePlaylists,
    editPlaylistNameSave,
    saveDurationChange,
    deleteContentFromPlaylist,
    onSync,
    onSetDemoPlaylist,
    isAdmin,
  } = props;
  const enableEdit = !order?.defaultPlaylist || isAdmin;

  const dispatch = useDispatch()

  const [isEditing, setIsEditing] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [changesObserver, setChangesObserver] = useState([])

  const [openExitDialog, setOpenExitDialog] = useState(false)

  const [isDrawerLoading, setIsDrawerLoading] = useState(false)

  const [playlistOptionsSync, setPlaylistOptionsSync] = useState({})

  const [placeholders, setPlaceholders] = useState({ landscape: '', portrait: '', resize: 'cover' })

  useEffect(() => {
    setPlaceholders({
      landscape: order?.placeholderLandscape || '',
      portrait: order?.placeholderPortrait || '',
      resize: order?.placeholderResize || 'cover',
    })
  }, [order?._id, order?.placeholderLandscape, order?.placeholderPortrait, order?.placeholderResize])

  const handlePlaceholdersChange = (next) => {
    setPlaceholders(next)
    const changed =
      next.landscape !== (order?.placeholderLandscape || '') ||
      next.portrait !== (order?.placeholderPortrait || '') ||
      next.resize !== (order?.placeholderResize || 'cover')
    setChangesObserver((prev) => [
      ...prev.filter((c) => c.type !== 'placeholderChange'),
      ...(changed ? [{ type: 'placeholderChange', change: next }] : []),
    ])
  }

  const { t } = useTranslation();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const handleEditOpen = useCallback(() => {
    setIsEditing(true);
  }, []);

  const handleEditCancel = useCallback(() => {
    setIsEditing(false);
  }, []);

  const handleSave = useCallback(
    (id, name) => {
      const isSameNamePlaylist = orders.find((p) => p.playlistName === name);
      if (name === "" || name === undefined) {
        toast.error(t("views.orderDrawer.nameFieldError"));
        return;
      } else if (isSameNamePlaylist) {
        toast.error(t("views.orderDrawer.sameNameError"));
      } else {
        editPlaylistNameSave(id, name);
        setIsEditing(false);
      }
    },
    [t]
  );

  const cofirmDialogAccept = () => {
    deletePlaylists(order._id);
    setConfirmDialogOpen(false);
    onClose();
  };

  useEffect(() => {
    setIsEditing(false);
  }, [order]);

  const resetChanges = () => {
    setChangesObserver([])
    setPlaceholders({
      landscape: order?.placeholderLandscape || '',
      portrait: order?.placeholderPortrait || '',
      resize: order?.placeholderResize || 'cover',
    })
    dispatch(getPlaylistsById('123'))
    onClose()
  }

  let content = null;

    const handleSyncPlaylistSettings = async () => {
        setIsDrawerLoading(true)
        console.log(order.content)
        const result = await dispatch(syncPlaylistSettings({
            playlistId: order._id,
            playlistNew: order.content.filter(cnt => Boolean(cnt.content)).map(c => {
                return {
                    content: c.content._id,
                    _id: c._id,
                    duration: c.duration
                }
            }),
            playlistOptions: playlistOptionsSync,
            placeholders
        }))
        console.log(result)
        setIsDrawerLoading(false)        
        if (!result) {
            toast.error("Error while saving playlist")  
        }else {
            toast.success("Successfully saved playlist settings")
            setChangesObserver([])
            onClose()
            onSync()
        }
    }  

  if (order) {
    content = (
      <div>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{
            px: 3,
            py: 2,
          }}>
          <Typography color="inherit" variant="h6">
            {order.playlistName}
          </Typography>
          <Stack alignItems="center" direction="row" flexWrap="wrap" justifyContent="flex-end" spacing={2}>
            {/* {!isEditing && enableEdit && (
              <Button onClick={handleEditOpen} size="small" variant="contained">
                {t("views.orderDrawer.editButton")}
              </Button>
            )}

            {enableEdit && (
              <Button color="error" onClick={() => setConfirmDialogOpen(true)} size="small" variant="outlined">
                {t("views.orderDrawer.deleteButton")}
              </Button>
            )} */}
            <IconButton color="inherit" onClick={() => changesObserver.length > 0 ? setOpenExitDialog(true) : onClose()}>
              <SvgIcon>
                <XIcon />
              </SvgIcon>
            </IconButton>
          </Stack>
        </Stack>
        <Box
          sx={{
            px: 3,
          }}>
          {!isEditing && enableEdit && (
            <PlaceholderPicker key={order?._id} value={placeholders} onChange={handlePlaceholdersChange} />
          )}
          {!isEditing ? ( 
            <>
              <OrderDetails
                onApprove={onClose}
                onEdit={handleEditOpen}
                onReject={onClose}
                order={order}
                onSelectFiles={() =>{
                    setChangesObserver((prev) => prev.find(c => c.type == 'addDelFile') ? prev : [...prev, {type: "addDelFile", change: {}}])
                    onSelectFiles()
                }}
                deletePlaylists={deletePlaylists}
                closeDrawer={onClose}
                saveDurationChange={saveDurationChange}
                handleEditOpen={handleEditOpen}
                handleDelete={() => setConfirmDialogOpen(true)}
                deleteContentFromPlaylist={(obj) => {
                    setChangesObserver((prev) => prev.find(c => c.type == 'addDelFile') ? prev : [...prev, {type: "addDelFile", change: {}}])
                    deleteContentFromPlaylist(obj)
                }}
                onSync={onSync}
                enableEdit={enableEdit}
                setChangesObserver={setChangesObserver}
                changesObserver={changesObserver}
                setPlaylistOptionsSync={setPlaylistOptionsSync}
              />

                <Box sx={{
                    py: 3,
                    
                }}>
                    <Button variant="contained" size="small" disabled={changesObserver.length == 0} sx={{
                        mr: 3,
                        width: "45%"
                    }} onClick={handleSyncPlaylistSettings}>Save & sync</Button>            
                    <Button variant="contained" size="small" disabled={changesObserver.length == 0} onClick={resetChanges} sx={{
                        width: "45%"
                    }}>Reset changes</Button>            
                </Box>              

              {order?.defaultPlaylist && !isAdmin && (
                <Button disabled variant="contained" sx={{ p: 1, mt: 1 }} fullWidth>
                  {t("views.addPlaylistModal.adminPlaylist")}
                </Button>
              )}

              {isAdmin && (
                <Button variant="contained" sx={{ p: 1, mt: 1 }} color="info" fullWidth onClick={() => onSetDemoPlaylist(order._id, order?.defaultPlaylist || false)}>
                  {!order?.defaultPlaylist ? <>{t("views.orderDrawer.setAsDemo")}</> : <>{t("views.orderDrawer.unsetAsDemo")}</>}
                </Button>
              )}

              <ConfirmDialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
                onAccept={cofirmDialogAccept}
                title={t("views.orderDrawer.confirmDialogTitle")}
              />
            </>
          ) : (
            <OrderEdit onCancel={handleEditCancel} onSave={handleSave} order={order} />
          )}
          <Dialog open={openExitDialog} sx={{
            p: 3
          }} maxWidth={"sm"} fullWidth>
            <Box sx={{
            p: 3
          }}>
                <Typography variant="subtitle1" textAlign={"center"}>There are unsaved changes in: <Typography variant="caption" textAlign={"center"}> <br />{order.playlistName}</Typography></Typography>
                
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    mt: 2,
                    gap: '20px'
                }}>
                    <Button variant="contained" size="small" onClick={() => setOpenExitDialog(false)}>Continue editing</Button>
                    <Button variant="contained" size="small" color="success" onClick={() => {
                        handleSyncPlaylistSettings()
                        setOpenExitDialog(false)
                    }}>Save</Button>
                    <Button variant="contained" size="small" color="error" onClick={() => {
                        setOpenExitDialog(false)
                        setChangesObserver([])
                        resetChanges()
                        onClose()
                    }}>Discard</Button>

                </Box>
            </Box>
          </Dialog>
        </Box>
      </div>
    );
  }

  if (lgUp) {
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={() => changesObserver.length > 0 ? setOpenExitDialog(true) : onClose()}
        PaperProps={{
          sx: {
            width: 700,
            zIndex: 200,
            py: 3
          },
        }}
        sx={{
            position: 'relative'
        }}
        >
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 100, position: 'absolute' })}
          open={isDrawerLoading}
        >
          <CircularProgress />
        </Backdrop>            
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      hideBackdrop
      ModalProps={{
        container,
        sx: {
          pointerEvents: "none",
          position: "absolute",
        },
      }}
      onClose={() => changesObserver.length > 0 ? setOpenExitDialog(true) : onClose()}
      open={open}
      PaperProps={{
        sx: {
          maxWidth: "100%",
          width: 600,
          pointerEvents: "auto",
          position: "absolute",
          py: 3,
          borderRadius: '10px'
        },
      }}
      SlideProps={{ container }}>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 100 })}
          open={isDrawerLoading}
        >
          <CircularProgress />
        </Backdrop>        
      {content}
    </Drawer>
  );
};

OrderDrawer.propTypes = {
  container: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  order: PropTypes.object,
};
